export default class ScrollHandler {
    constructor() {
        this.body = document.querySelector("body");
        this.lockedScrollPos = 0;
    }

    disableScroll() {
        this.lockedScrollPos  = window.scrollY;

        document.documentElement.classList.add("stop-scrolling");
        this.body.classList.add("stop-scrolling");
        this.body.style.top = `-${this.lockedScrollPos}px`;
    }

    enableScroll() {
        this.body.classList.remove("stop-scrolling");
        this.body.style.top = null;
        window.scrollTo(0,this.lockedScrollPos);  
        document.documentElement.classList.remove("stop-scrolling");
    }
}